import React, { useMemo } from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import {
  makeStyles,
} from 'lib/components';
import SelectField from 'commonComponents/select-field';
import { MEASUREMENT_REQUEST_TYPES } from 'constants/AppConstants';
import { gainsightPxCustomEvent } from 'utils/gainsightPx.utils';
import { GAINSIGHT_PX_EVENT_MEASUREMENT_INSTRUCTION_SELECTED } from 'constants/gainsightPxCustomEvents.constants';
import { filterMeasurementRequestTypes, isPropertyDataSelected as checkIsPropertyDataSelected } from '../../features/order/Order.utils';
import { setSelectedMeasurementRequest } from '../../features/order/Order.actions';

const useStyles = makeStyles((theme) => ({
  measurementInstructionsSelect: {
    flex: 1,
    color: theme.evPalette.charcoal[900],
  },
}));

function MeasurementInstructionsHelper(props) {
  const {
    propertyType,
    selectedMeasurementRequest,
    selectedPrimaryProduct,
    selectedWallsProduct,
  } = useSelector((state) => state.order);
  const dispatch = useDispatch();
  const classes = useStyles();

  // #genai - Preserve primary-product precedence while safely reading absent selections.
  const selectedProductId = selectedPrimaryProduct?.ProductID
    || selectedWallsProduct?.ProductID;

  // Check if Property Data is selected
  const isPropertyDataSelected = checkIsPropertyDataSelected(selectedPrimaryProduct);

  const measurementRequestOptions = useMemo(() => (
    MEASUREMENT_REQUEST_TYPES.filter(filterMeasurementRequestTypes(propertyType, selectedProductId, isPropertyDataSelected))
  ), [propertyType, selectedProductId, isPropertyDataSelected]);
  const { id: selectedValue } = measurementRequestOptions.find(({ id }) => id === selectedMeasurementRequest) || measurementRequestOptions[0];

  const handleChange = ({ target: { value } }) => {
    dispatch(setSelectedMeasurementRequest(value));
    gainsightPxCustomEvent(GAINSIGHT_PX_EVENT_MEASUREMENT_INSTRUCTION_SELECTED, { measurementInstructionId: Number(value) });
  };

  return (
    <SelectField
      variant="outlined"
      selectedValue={Number(selectedValue)}
      handleChange={handleChange}
      selectOptions={measurementRequestOptions}
      className={classes.measurementInstructionsSelect}
      {...props}
    />
  );
}

export default MeasurementInstructionsHelper;
